import { createAction, props } from '@ngrx/store';
import { Status } from 'src/app/shared/types/status.types';

export const StatusesLoad = createAction('[STATUSES] Load statuses');
export const StatusesLoadSuccess = createAction('[STATUSES] Load statuses successful', props<{ statuses: Status[] }>());
export const StatusesLoadError = createAction('[STATUSES] Load statuses failed');
